// services/api.js

export const getStoredToken = () => {
  try {
    return JSON.parse(localStorage.getItem("token") || "null")
  } catch (e) {
    return null
  }
}

export const getAccessToken = () => getStoredToken()?.access_token

export const getHeaders = (lang) => {
  const headers = new Headers()
  headers.set("Accept", "application/json")
  if (lang) headers.set("Accept-Language", lang)

  const access = getAccessToken()
  if (access) headers.set("Authorization", `Bearer ${access}`)

  return headers
}

export const apiCall = async (request) => {
  const res = await fetch(request)

  const contentType = res.headers.get("content-type") || ""
  const body = contentType.includes("application/json")
    ? await res.json().catch(() => null)
    : await res.text().catch(() => null)

  if (!res.ok) {
    if (res.status === 401 || res.status === 403) {
      localStorage.removeItem("token")
    }
    return { type: "error", status: res.status, body }
  }

  return body
}
